// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IAuditActor } from './IAuditActor';
import {
    IAuditActorFromJSON,
    IAuditActorFromJSONTyped,
    IAuditActorToJSON,
    IAuditActorToJSONTyped,
} from './IAuditActor';

/**
 * 
 * @export
 * @interface IPatchLinkedSystemTemplatesDto
 */
export interface IPatchLinkedSystemTemplatesDto {
    /**
     * 
     * @type {Set<number>}
     * @memberof IPatchLinkedSystemTemplatesDto
     */
    template_ids?: Set<number>;
    /**
     * 
     * @type {IAuditActor}
     * @memberof IPatchLinkedSystemTemplatesDto
     */
    audit_actor?: IAuditActor;
}

/**
 * Check if a given object implements the IPatchLinkedSystemTemplatesDto interface.
 */
export function instanceOfIPatchLinkedSystemTemplatesDto(value: object): value is IPatchLinkedSystemTemplatesDto {
    return true;
}

export function IPatchLinkedSystemTemplatesDtoFromJSON(json: any): IPatchLinkedSystemTemplatesDto {
    return IPatchLinkedSystemTemplatesDtoFromJSONTyped(json, false);
}

export function IPatchLinkedSystemTemplatesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPatchLinkedSystemTemplatesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'template_ids': json['template_ids'] == null ? undefined : new Set(json['template_ids']),
        'audit_actor': json['audit_actor'] == null ? undefined : IAuditActorFromJSON(json['audit_actor']),
    };
}

export function IPatchLinkedSystemTemplatesDtoToJSON(json: any): IPatchLinkedSystemTemplatesDto {
    return IPatchLinkedSystemTemplatesDtoToJSONTyped(json, false);
}

export function IPatchLinkedSystemTemplatesDtoToJSONTyped(value?: IPatchLinkedSystemTemplatesDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'template_ids': value['template_ids'] == null ? undefined : Array.from(value['template_ids'] as Set<any>),
        'audit_actor': IAuditActorToJSON(value['audit_actor']),
    };
}

